import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    inject,
    Output,
} from '@angular/core';

import { SharedUiModule } from '@pf/shared-ui';
import { CpwTaskStateService } from '@cpw/domain';

@Component({
    selector: 'cpw-task-filters',
    standalone: true,
    imports: [SharedUiModule],
    templateUrl: './cpw-task-filters.component.html',
    styleUrls: ['./cpw-task-filters.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpwTaskFiltersComponent {
    private readonly taskService = inject(CpwTaskStateService);

    @Output() filtersCleared = new EventEmitter<void>();

    clearFilters() {
        this.taskService.clearTaskFilters();
        this.filtersCleared.emit();
    }
}
